export default __webpack_public_path__ + "static/media/locusofcontrol1Img6.b8a3f42c.png";